import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { TextField } from '.';
import { PatientRequestViewModelFragment, usePatientInfoQuery } from '../graphql';
import { defaultDateFormat, defaultDateFormatWithAge } from '../utils';

interface SelectedPatientProps {
  patient?: PatientRequestViewModelFragment;
}

export const SelectedPatient = ({ patient }: SelectedPatientProps) => {
  if (!patient) return null;

  const { data: patientData } = usePatientInfoQuery({ variables: { patientId: patient.patientId.toString() } });

  return (
    <div className='bg-light-gray mb-4'>
      <p className='patient-select-text'>PATIENT INFORMATION</p>
      <Form>
        <Row>
          <Form.Group sm={2} as={Col} controlId='patient_first_name'>
            <TextField
              disabled
              required={true}
              className='patient-select-text'
              label='First Name:'
              name='patient_first_name'
              defaultValue={patient.firstName}
              plaintext
              readOnly
              data-testid='cmx__selected-patient-first-name'
            />
          </Form.Group>
          <Form.Group sm={2} as={Col} controlId='patient_middle_name'>
            <TextField
              disabled
              required={true}
              className='patient-select-text'
              label='Middle Name:'
              name='patient_middle_name'
              defaultValue={patient.middleName}
              plaintext
              readOnly
              data-testid='cmx__selected-patient-middle-name'
            />
          </Form.Group>
          <Form.Group sm={2} as={Col} controlId='patient_last_name'>
            <TextField
              disabled
              required={true}
              className='patient-select-text'
              label='Last Name:'
              name='patient_last_name'
              defaultValue={patient.lastName}
              plaintext
              readOnly
              data-testid='cmx__selected-patient-last-name'
            />
          </Form.Group>
          <Form.Group sm={2} as={Col} controlId='suffix'>
            <TextField
              disabled
              required={true}
              className='patient-select-text'
              label='Suffix:'
              name='suffix'
              defaultValue={patient.suffix ?? '--'}
              plaintext
              readOnly
              data-testid='cmx__selected-suffix'
            />
          </Form.Group>
          <Form.Group sm={2} as={Col} controlId='dob'>
            <TextField
              disabled
              required={true}
              className='patient-select-text'
              label='Date of Birth(Age):'
              name='dob'
              defaultValue={defaultDateFormat(patient.dob)}
              format={(value: string) => defaultDateFormatWithAge(value)}
              plaintext
              readOnly
              data-testid='cmx__selected-date-of-birth'
            />
          </Form.Group>
          <Form.Group sm={2} as={Col} controlId='gender'>
            <TextField
              disabled
              required={true}
              className='patient-select-text'
              label='Gender:'
              name='gender'
              defaultValue={patient.gender ?? '--'}
              plaintext
              readOnly
              data-testid='cmx__selected-patient-gender'
            />
          </Form.Group>
        </Row>
      </Form>
      <Form>
        <Row>
          <Form.Group sm={2} as={Col} controlId='patient_streetAddress'>
            <TextField
              disabled
              required={true}
              className='patient-select-text'
              label='Street Address:'
              name='patient_streetAddress'
              defaultValue={patientData?.result?.address?.address1 ?? '--'}
              plaintext
              readOnly
              data-testid='cmx__selected-patient-street-address'
            />
          </Form.Group>
          <Form.Group sm={2} as={Col} controlId='patient_Address2'>
            <TextField
              disabled
              required={true}
              className='patient-select-text'
              label='Address 2:'
              name='patient_Address2'
              defaultValue={patientData?.result?.address?.address2 ?? '--'}
              plaintext
              readOnly
              data-testid='cmx__selected-patient-street-address'
            />
          </Form.Group>
          <Form.Group sm={2} as={Col} controlId='patient_city'>
            <TextField
              disabled
              required={true}
              className='patient-select-text'
              label='City, State:'
              name='patient_city'
              defaultValue={`${patientData?.result?.address?.city ?? '--'}, ${
                patientData?.result?.address?.state ?? '--'
              }`}
              plaintext
              readOnly
              data-testid='cmx__selected-patient-street-address'
            />
          </Form.Group>
          <Form.Group sm={2} as={Col} controlId='patient_zip'>
            <TextField
              disabled
              required={true}
              className='patient-select-text'
              label='Zip Code:'
              name='patient_zip'
              defaultValue={patientData?.result?.address?.zip ?? '--'}
              plaintext
              readOnly
              data-testid='cmx__selected-patient-street-address'
            />
          </Form.Group>
          <Form.Group sm={2} as={Col} controlId='patient_homeNumber'>
            <TextField
              disabled
              required={true}
              className='patient-select-text'
              label='Home Phone:'
              name='patient_homeNumber'
              defaultValue={
                patientData?.result?.phoneNumbers?.find((phone) => phone?.phoneType?.toLowerCase() === 'home')
                  ?.phoneNumber ?? '--'
              }
              plaintext
              readOnly
              data-testid='cmx__selected-patient-phoneNumber'
            />
          </Form.Group>
          <Form.Group sm={2} as={Col} controlId='patient_mobileNumber'>
            <TextField
              disabled
              required={true}
              className='patient-select-text'
              label='Mobile Phone:'
              name='patient_mobileNumber'
              defaultValue={
                patientData?.result?.phoneNumbers?.find((phone) => phone?.phoneType?.toLowerCase() === 'mobile')
                  ?.phoneNumber ?? '--'
              }
              plaintext
              readOnly
              data-testid='cmx__selected-patient-phoneNumber'
            />
          </Form.Group>
        </Row>
      </Form>
    </div>
  );
};
